<template>
  <div class="advertiseInfoWrapper">
    <div class="leftSideWrapper">
      <div class="leftSideContentWrapper">
        <div class="largeHeadLine">상세정보</div>
        <div class="mainContentsWrapper">
          <div class="stateAndBudgetInfoDiv">
            <div class="stateInfo">
              <img v-bind:src="stateImg">
              <span>{{$moment(adInfo.startAt).format('yy.MM.DD').substring(2, $moment(adInfo.startAt).format('yy.MM.DD').length)
              + ' ~ '
              + $moment(adInfo.endAt).format('yy.MM.DD').substring(2, $moment(adInfo.endAt).format('yy.MM.DD').length)}}</span>
            </div>
            <div class="totalBudgetInfo">
              <span>총예산 </span>
              <span>{{ (adInfo.period * adInfo.dailyBudget).toLocaleString() + '원' }}</span>
            </div>
          </div>
          <div class="sectionLine"></div>
          <div class="tableInfoDiv">
            <div class="tableHeader">
              <div></div>
              <div>도달수</div>
              <div>답변수</div>
              <div>답변당 단가</div>
            </div>
            <div class="tableDataDiv">
              <div class="tableData" v-for="(td, index) in tableData" v-bind:key="index">
                <div>{{$moment(td.date).format('yy.MM.DD')}}</div>
                <div>{{td.exposedCnt + '명'}}</div>
                <div>{{td.answeredCnt + '회'}}</div>
                <div>{{td.pricePerClick.toLocaleString() + '원'}}</div>
              </div>
            </div>
          </div>
          <div class="sectionLine"></div>
          <div class="rewardAndGroupInfoDiv">
            <span class="itemName">보상방법</span>
            <div class="rewardInfo">
              <img v-bind:src="rewardImg">
              <span>{{adInfo.rewardType === 'COUPON' ? adInfo.rewardCoupons[0].title : '+' + adInfo.rewardPoint + '포인트'}}</span>
            </div>
            <span class="itemName">투표대상</span>
            <div class="targetGroupInfo">
              <span>{{adInfo.targetGroup === 0 ? '폴라이드 유저 모두' : '나의 팔로워만'}}</span>
            </div>
          </div>
          <div class="sectionLine"></div>
          <div class="genderAndAgeRateInfoDiv">
            <div class="genderRateDiv">
              <span class="itemName">성별비율</span>
              <div class="genderRateChart">
                <pie-chart v-bind:chart-data-prop="genderRateChartData"></pie-chart>
              </div>
            </div>
            <div class="ageRateDiv">
              <span class="itemName">연령비율</span>
              <div class="ageRateHorizontalChart">
                <div class="ageChartRow" v-for="(items, index) in ageRateChartData" v-bind:key="index">
                  <div class="label">{{items.label}}</div>
                  <div class="chartBar" v-bind:style="items.ageBarWidth"></div>
                  <div class="valueText">{{items.value + '%'}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="jobRateInfoDiv">
            <span class="itemName">직업비율</span>
            <div class="jobRateDiv">
              <div class="jobRateProp" v-for="(jobData, index) in jobRateData" v-bind:key="index">
                <div>
                  <span>{{jobData.jobName}}</span>
                  <br>
                  <span>{{jobData.value + '%'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionLine"></div>
          <div class="districtRateInfoDiv">
            <span class="itemName">지역비율</span>
            <div class="districtRateDiv">
              <div class="districtMapDiv">
                <district-map v-bind:district-rate-data="districtRateData"></district-map>
              </div>
              <div class="districtTableDiv">
                <div class="districtTableHeader">
                  <div>지역</div>
                  <div>지역구</div>
                  <div>비율</div>
                </div>
                <div class="districtTableData" v-for="(td, index) in districtRateData" v-bind:key="index">
                  <div>{{td.regionName}}</div>
                  <div>{{td.districtName}}</div>
                  <div>{{td.districtRate + '%'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <board-footer></board-footer>
    </div>
    <div class="rightSideWrapper">
      <advertise-ui v-bind:data="uiPropData"></advertise-ui>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
import pieChart from '../elements/pieChart'
import horizontalBarChart from '../elements/horizontalBarChart'
import districtMap from '../elements/districtMap'
import advertiseUI from '../elements/advertiseUI'
import boardFooterLeftSide from '../elements/boardFooterLeftSide'
import utils from '../../../assets/js/utils'
import params from '../../../params'

export default {
  components: {
    'pie-chart': pieChart,
    'horizontal-bar-chart': horizontalBarChart,
    'district-map': districtMap,
    'advertise-ui': advertiseUI,
    'board-footer': boardFooterLeftSide
  },
  data () {
    return {
      stateImg: null,
      rewardImg: null,
      rewardText: null,
      adInfo: {
        // 광고 정보
        startAt: '',
        endAt: '',
        dailyBudget: 0,
        rewardType: '',
        targetGroup: 0,
        rewardCoupons: [],
        status: null,
        period: 0
      },
      // 날짜에 따른 각종 횟수 정보
      tableData: null,
      // 성별 통계 data
      // eslint-disable-next-line no-new-object
      genderRateChartData: [],
      // 성별 통계 data
      // eslint-disable-next-line no-new-object
      ageRateChartData: new Object(),
      jobRateData: null,
      districtList: null,
      districtRateData: null,
      // 핸드폰 UI프롭 데이터
      uiPropData: {
        isRewardTypeCoupon: false,
        titleText: null,
        titleImg: null,
        answerText: [null, null, null, null],
        answerImg: [null, null, null, null]
      }
    }
  },
  methods: {
    setAdInfo: function (data) {
      let startAtDate = new Date(this.$moment(data.startAt.split(' ')[0], 'YYYY-MM-DD').format('YYYY-MM-DD'))
      // DB에 저장된 값은 다음날 00시 이므로 -1처리를 해줘야됨
      let endAtDate = new Date(this.$moment(data.endAt.split(' ')[0], 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD'))
      let adInfo = {
        startAt: startAtDate,
        endAt: endAtDate,
        dailyBudget: data.dailyBudget,
        rewardType: data.rewardType,
        targetGroup: data.targetGroup,
        status: data.status,
        rewardCoupons: data.rewardCoupons,
        rewardPoint: data.rewardPoint,
        period: parseInt(parseInt(endAtDate.getTime() - startAtDate.getTime()) / (1000 * 3600 * 24)) + 1
      }
      this.adInfo = adInfo
    },
    setAdStats: function (adInfo, adStat) {
      this.setTableData(adInfo.rewardPoint, adInfo.startAt, adInfo.endAt, adStat.dailyReport)
      this.setGenderRate(adStat.genderRate)
      this.setAgeRate(adInfo.targetAgeGroups, adStat.ageRate)
      this.setJobRate(adInfo.targetJobs, adStat.jobRate)
      this.setDistrictRate(adInfo.targetAreas, adStat.districtRate)
    },
    setTableData: function (rewardPoint, startAt, endAt, dailyReport) {
      let tableData = []
      let startMilSec = this.$moment(this.$moment(startAt.split(' ')[0], 'YYYY-MM-DD').format('YYYY-MM-DD')).valueOf()
      // DB에 저장된 값은 다음날 00시 이므로 -1처리를 해줘야됨
      let endMilSec = this.$moment(this.$moment(endAt.split(' ')[0], 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD')).valueOf()

      for(var i = startMilSec; i <= endMilSec; i += 86400000) {
        let dayData = dailyReport.find(items => items.date === i)
        if(dayData != null) {
          tableData.push(dayData)
        }else {
          tableData.push(
            {
              answeredCnt: 0,
              date: i,
              exposedCnt: 0,
              pricePerClick: dailyReport.length !== 0 ? dailyReport[0].pricePerClick : rewardPoint
            }
          )
        }
      }
      this.tableData = tableData
    },
    setGenderRate: function (genderRate) {
      let genderRateChartData
      genderRateChartData = [
        {
          label: '남성',
          value: genderRate.maleCnt
        },
        {
          label: '여성',
          value: genderRate.femaleCnt
        },
        {
          label: '성별모름',
          value: genderRate.unknownCnt
        }
      ]
      this.genderRateChartData = genderRateChartData
    },
    setAgeRate: function (ageGroups, ageRate) {
      let ageRateChartData = []
      // 배열 sort
      ageGroups.sort(function (a, b) { // 오름차순
        return a - b
      })

      for (var i = 0; i < ageGroups.length; i++) {
        switch (ageGroups[i]) {
          case 0:
            ageRateChartData.push({
              label: '0 ~ 10세',
              value: ageRate.age10Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.age10Cnt) * 1.5 + 20) + 'px;'
            })
            break
          case 1:
            ageRateChartData.push({
              label: '11 ~ 20세',
              value: ageRate.age20Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.age20Cnt) * 1.5 + 20) + 'px;'
            })
            break
          case 2:
            ageRateChartData.push({
              label: '21 ~ 30세',
              value: ageRate.age30Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.age30Cnt) * 1.5 + 20) + 'px;'
            })
            break
          case 3:
            ageRateChartData.push({
              label: '31 ~ 40세',
              value: ageRate.age40Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.age40Cnt) * 1.5 + 20) + 'px;'
            })
            break
          case 4:
            ageRateChartData.push({
              label: '41 ~ 50세',
              value: ageRate.age50Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.age50Cnt) * 1.5 + 20) + 'px;'
            })
            break
          case 5:
            ageRateChartData.push({
              label: '51세 이상',
              value: ageRate.ageOver50Cnt,
              ageBarWidth: 'width: ' + (parseInt(ageRate.ageOver50Cnt) * 1.5 + 20) + 'px;'
            })
            break
          default:
            break
        }
      }
      this.ageRateChartData = ageRateChartData
    },
    setJobRate: function (jobs, jobRate) {
      let jobRateData = []
      // 배열 sort
      jobs.sort(function (a, b) { // 오름차순
        return a - b
      })

      for (var i = 0; i < jobs.length; i++) {
        switch (jobs[i]) {
          case 0:
            jobRateData.push(
              {
                jobName: '초/중/고생',
                value: jobRate.studentCnt
              }
            )
            break
          case 1:
            jobRateData.push(
              {
                jobName: '대학(원)생',
                value: jobRate.collegeCnt
              }
            )
            break
          case 2:
            jobRateData.push(
              {
                jobName: '스타트업',
                value: jobRate.startUpCnt
              }
            )
            break
          case 3:
            jobRateData.push(
              {
                jobName: '회사원',
                value: jobRate.employeeCnt
              }
            )
            break
          case 4:
            jobRateData.push(
              {
                jobName: '공무원',
                value: jobRate.functionaryCnt
              }
            )
            break
          case 5:
            jobRateData.push(
              {
                jobName: '자영업자',
                value: jobRate.selfEmployedCnt
              }
            )
            break
          case 6:
            jobRateData.push(
              {
                jobName: '전문직',
                value: jobRate.professionCnt
              }
            )
            break
          case 7:
            jobRateData.push(
              {
                jobName: '주부',
                value: jobRate.homeMakerCnt
              }
            )
            break
          case 8:
            jobRateData.push(
              {
                jobName: '기타',
                value: jobRate.etcJobCnt
              }
            )
            break
          default:
            break
        }
      }
      this.jobRateData = jobRateData
    },
    setDistrictRate: async function (areas, districtRate) {
      let formattedAreaArr = utils.setPackedAreas(areas)
      let regionList = this.$store.getters.getRegionList

      let unpackedRateData = []
      // eslint-disable-next-line no-redeclare
      for(var i = 0; i < formattedAreaArr.length; i++) {
        if (formattedAreaArr[i] > 0) {
          // 구역 1개인 경우
          unpackedRateData.push({
            originalId: formattedAreaArr[i],
            districtId: [formattedAreaArr[i]],
            districtCnt: 0
          })
        }else {
          let regionName = regionList.find(items => items.id === (formattedAreaArr[i] * -1)).name
          let sameRegionDistrict = [...new Set(this.districtList.filter(items => items.regionName === regionName).map(items => items.id))]
          unpackedRateData.push({
            originalId: formattedAreaArr[i],
            districtId: sameRegionDistrict,
            districtCnt: 0
          })
        }
      }

      let data = districtRate
      let totalCnt = 0
      // eslint-disable-next-line no-redeclare
      for(var i = 0; i < data.districtId.length; i++) {
        let selectedData = unpackedRateData.find(items => items.districtId.includes(data.districtId[i]))
        if (selectedData != null) {
          selectedData.districtCnt += data.districtCnt[i]
          totalCnt += data.districtCnt[i]
        }
      }

      let districtRateData = []
      // eslint-disable-next-line no-redeclare
      for(var i = 0; i < unpackedRateData.length; i++) {
        if(unpackedRateData[i].originalId < 0) {
          districtRateData.push({
            regionName: regionList.find(items => items.id === (unpackedRateData[i].originalId * -1)).name,
            districtName: '전체',
            districtRate: totalCnt !== 0 ? parseInt(unpackedRateData[i].districtCnt * 100 / totalCnt) : 0
          })
        } else {
          districtRateData.push({
            regionName: this.districtList.find(items => items.id === unpackedRateData[i].originalId).regionName,
            districtName: this.districtList.find(items => items.id === unpackedRateData[i].originalId).name,
            districtRate: totalCnt !== 0 ? parseInt(unpackedRateData[i].districtCnt * 100 / totalCnt) : 0
          })
        }
      }
      this.districtRateData = districtRateData
    },
    setStateImg: function () {
      if (this.adInfo.status === 'WAITING') {
        this.stateImg = require('@/assets/img/advertise_waiting_state_icon.png')
      } else if (this.adInfo.status === 'ON_PROGRESS') {
        this.stateImg = require('@/assets/img/advertise_progressing_state_icon.png')
      } else if (this.adInfo.status === 'COMPLETED') {
        this.stateImg = require('@/assets/img/advertise_complete_state_icon.png')
      } else if (this.adInfo.status === 'STOPPED_BY_ADMIN' || this.adInfo.status === 'STOPPED_INSUFFICIENT_POINTS') {
        this.stateImg = require('@/assets/img/advertise_reported_state_icon.png')
      }
    },
    setRewardImg: function () {
      if (this.adInfo.rewardType === 'COUPON') {
        this.rewardImg = require('@/assets/img/reward_coupon_icon.png')
      }else if (this.adInfo.rewardType === 'POLLIDE_POINT') {
        this.rewardImg = require('@/assets/img/reward_point_icon.png')
      }
    },
    setAllDistrictList: function (districtAllData) {
      this.districtList = JSON.parse(JSON.stringify(districtAllData))
    },
    setUIProps: function (adInfoData) {
      let answerText = []
      let answerImg = []
      for(var i = 0; i < adInfoData.adChoices.length; i++) {
        answerText.push(
          adInfoData.adChoices[i].choiceText != null ? adInfoData.adChoices[i].choiceText : null
        )

        answerImg.push(
          adInfoData.adChoices[i].choiceImg != null ? adInfoData.adChoices[i].choiceImg : null
        )
      }

      let categoryParams = params.category
      let category = categoryParams.find(items => items.itemKey === adInfoData.category).text

      this.uiPropData = {
        isRewardTypeCoupon: adInfoData.rewardType === 'COUPON',
        titleText: adInfoData.questionText,
        titleImg: adInfoData.questionSource,
        category: category,
        answerText: answerText,
        answerImg: answerImg,
        answerCount: adInfoData.adChoices.length
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let adInfoResponse = await store.dispatch('adInfoApi', {adId: to.params.adId})
      let adStatResponse = await store.dispatch('adStatApi', {adId: to.params.adId})
      // 에러처리
      if(adInfoResponse.data.result.code === 3000 || adInfoResponse.data.result.code === 3003) {
        // 존재하지 않는 광고(3000), 내광고가 아닌 광고(3003)
        next({name: 'list', replace: true})
      }else{
        next(vm => {
          vm.setAdInfo(adInfoResponse.data.data)
          vm.setUIProps(adInfoResponse.data.data)
          vm.setAllDistrictList(store.getters.getDistrictAllList)
          vm.setAdStats(adInfoResponse.data.data, adStatResponse.data.data)
          vm.setStateImg()
          vm.setRewardImg()
        })
      }
    }catch (error) {
      console.log(error.response)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.advertiseInfoWrapper{
  display : -webkit-flex;
  display : flex;
  margin: 0;
  padding: 0;
  flex: 1;
}

.leftSideWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  background-color: white;
  width: 620px;
}

.leftSideContentWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  padding: 0 32px;
  height: calc(100% - 82px);
}

.rightSideWrapper{
  position: relative;
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  width: 356px;
  align-items: center;
  padding-top: 120px;
  background-color: rgb(245,246,250)
}

.mainContentsWrapper{
  position: relative;
  flex: 1;
  margin: 0;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mainContentsWrapper::-webkit-scrollbar{
  display: none;
}

.stateAndBudgetInfoDiv{
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.stateAndBudgetInfoDiv > .totalBudgetInfo{
  font-size: 13px;
}

.totalBudgetInfo > span:nth-child(2){
  font-weight: bold;
}

.stateAndBudgetInfoDiv > .stateInfo{
  display : -webkit-flex;
  display : flex;
  align-items: center;
  width: 250px;
}

.stateInfo > img{
  width: 48px;
  height: 24px;
}

.stateInfo > span{
  margin-left: 15px;
  font-size: 11px;
}

.tableInfoDiv {
  position: relative;
  font-size: 11px;
  padding: 24px 32px 24px 32px;
  height: 224px;
}

.tableDataDiv{
  height: calc(100% - 40px);
  font-size: 11px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tableDataDiv::-webkit-scrollbar{
  display: none;
}

.tableDataDiv > .tableData:nth-child(2n+1){
  background-color: #F2F2F2;
}

.tableHeader, .tableData{
  display : -webkit-flex;
  display : flex;
}

.tableHeader > div, .tableData > div{
  flex: 0.25;
  text-align: center;
  padding: 10px 0;
  border-bottom: black solid 1px;
}

.tableHeader > div:nth-child(1), .tableData > div:nth-child(1){
  border-right: black solid 1px;
}

.itemName {
  font-size: 11px;
  color: rgb(0,153,255);
}

.rewardAndGroupInfoDiv {
  padding: 32px 0;
}

.rewardInfo, .targetGroupInfo{
  display : -webkit-flex;
  display : flex;
  align-items: center;
  font-size: 11px;
  padding: 24px 0;
}

.rewardInfo > img{
  height: 48px;
  width: 48px;
  margin-right: 10px;
}

.genderAndAgeRateInfoDiv{
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  padding: 24px 0;
}

.genderRateDiv{
  width: 278px;
}

.genderRateDiv > .genderRateChart{
  padding: 20px 0;
  width: 238px;
  height: 238px;
}

.ageRateDiv{
  width: 278px;
}

.ageRateDiv > .ageRateHorizontalChart{
  padding: 20px 0;
  width: 100%;
  height: 238px;
}

.ageRateHorizontalChart > .ageChartRow {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  width: 100%;
  height: 24px;
  margin: 15px 0;
}

.ageChartRow > .label{
  width: 60px;
  font-size: 11px;
}

.ageChartRow > .chartBar{
  height: 20px;
  border: 2px solid #0099FF;
  margin-right: 10px;
  width: 20px;
  border-radius: 0 16px 16px 0;;
}

.ageChartRow > .valueText{
  font-size: 11px;
  color: #0099FF;
}

.jobRateDiv{
  display : -webkit-flex;
  display : flex;
  flex-wrap : wrap;
  padding: 12px 0 46px 0;
}

.jobRateProp{
  padding-top: 10px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 20%;
}

.jobRateProp > div {
  padding-top: 15px;
  border: 2px solid #0099FF;
  border-radius: 2rem;
  width: 96px;
  height: 41px;
  font-size: 11px;
  text-align: center;
}

.districtRateDiv{
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  padding: 24px 0;
}

.districtMapDiv{
  flex: 0.5;
  background-color: #F2F2F2;
}

.districtTableDiv{
  flex: 0.5;
  font-size: 11px;
  padding-left: 20px;
}

.districtTableDiv > .districtTableData:nth-child(2n){
  background-color: #F2F2F2;
}

.districtTableHeader, .districtTableData{
  display : -webkit-flex;
  display : flex;
}

.districtTableHeader {
  background-color: black;
  color: white;
}

.districtTableHeader > div:first-child, .districtTableData > div:first-child{
  flex: 0.4;
  padding: 15px 10px;
}

.districtTableHeader > div:nth-child(2), .districtTableData > div:nth-child(2){
  flex: 0.4;
  padding: 15px 10px;
}

.districtTableHeader > div:last-child, .districtTableData > div:last-child{
  flex: 0.2;
  padding: 15px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/advertiseInfo.vue